import { findTjn } from '@bn-apps/dim-ui-react/tjn';

const SPEED_SIGNS = new Set(['68A', '68B', '68C']);
const KM_SIGNS = new Set(['75A', '75B']);

/**
 * What a TJN sign writes, from the object's data: the km of a kilometre post (km in metres, 49500 → 49,5) and,
 * until the data carries it, a speed sign's label of whole km/h in tens (90 → 9). A sign with a value but no data
 * gets an empty one, so it shows no example number; other signs get none.
 */
export function signValue(
  code: string | null | undefined,
  { label, km }: { label?: string; km?: number | null }
): string | undefined {
  const entry = code ? findTjn(code) : undefined;
  if (!entry?.value) return undefined;
  if (SPEED_SIGNS.has(entry.id)) {
    return label && /^\d+$/.test(label.trim()) ? String(Math.round(Number(label) / 10)) : '';
  }
  if (KM_SIGNS.has(entry.id) && km != null) return (km / 1000).toFixed(1).replace('.', ',');
  return '';
}
